import { push } from "connected-react-router";

import {
  getPollInfo,
  changePollVisibility,
} from '../../request';

import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, showSuccessMessage } from "./ui";

//Загрузка информации об опросе
export const POLL_INFO_LOADING_START = "Poll info loading start";
export const POLL_INFO_LOADED_SUCCESSFULLY = "Poll info loaded successfully";
export const POLL_INFO_LOADING_FAILED = "Failure during poll info load";

//Изменение видимости опроса
export const POLL_VISIBILITY_CHANGE_START = "Poll deletion start";
export const POLL_VISIBILITY_CHANGED_SUCCESSFULLY = "Poll deleted successfully";
export const POLL_VISIBILITY_CHANGE_FAILED = "Failure during poll deletion";

const startLoading = () => ({
  type: POLL_INFO_LOADING_START 
});

const loadSuccess = poll => ({
  type: POLL_INFO_LOADED_SUCCESSFULLY,
  payload: {
    poll: poll || {}
  }
});

const loadFailure = () => ({
  type: POLL_INFO_LOADING_FAILED,
});

//ЗАГРУЗКА ИНФОРМАЦИИ ОБ ОПРОСЕ
export const getPollInfoAsync = pollId => { 
  return async (dispatch) => {
    dispatch(startLoading());
    await dispatch(checkAndRenewTokens());
    let poll;
    const accessToken = localStorage.getItem("accessToken");
    try {
      poll = await getPollInfo(accessToken, pollId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке опроса!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(poll));
  };
};

//ИЗМЕНЕНИЕ ВИДИМОСТИ ОПРОСА
const startVisibilityChange = () => ({
  type: POLL_VISIBILITY_CHANGE_START
});

const visibilityChangeSuccess = () => ({ 
  type: POLL_VISIBILITY_CHANGED_SUCCESSFULLY,
});

const visibilityChangeFailure = () => ({
  type: POLL_VISIBILITY_CHANGE_FAILED,
});

export const changePollVisibilityAsync = (status, pollId) => { 
  return async (dispatch) => {
    dispatch(startVisibilityChange());
    await dispatch(checkAndRenewTokens());
    const data = { status };
    try {
      const accessToken = localStorage.getItem("accessToken");
      await changePollVisibility(accessToken, data, pollId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при изменении видимости опроса"));
      return dispatch(visibilityChangeFailure());
    }
    dispatch(push('/polls'))
    //В данном случае всегда только скрываем опрос, хотя api допускает оба варианта
    dispatch(showSuccessMessage('Опрос скрыт от пользователей'));
    return dispatch(visibilityChangeSuccess());
  };
};
